import React, {useState} from 'react';
import {useDispatch} from 'react-redux'
import {useNavigate} from "react-router-dom";
import logo from '../../assets/mvp-logo-black.svg';
import loginWithMicrosoft from '../../assets/login-with-microsoft.png';
import * as Routes from "../../utils/routes";
import {getAuth, OAuthProvider, signInWithPopup} from "firebase/auth";
import * as userActions from '../../redux/User/actions';
import LoadingPanel from "../../components/LoadingPanel";
import app from '../../utils/firebase';
import ball1 from '../../assets/home/ball1.png';
import ball2 from '../../assets/home/ball2.png';
import ball3 from '../../assets/home/ball3.png';
import FloatingImage from "../../components/FloatingImage";

import './InternalSignInPage.scss';
import constants from '../../utils/constants';
import Toaster from '../../components/Toaster';

const auth = getAuth(app);

const InternalSignInPage = props => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const signIn = async () => {
		await setLoading(true);

		const provider = new OAuthProvider('microsoft.com');

		provider.setCustomParameters({
			prompt: "consent",
			tenant: process.env.REACT_APP_TENANT_ID
		});

		signInWithPopup(auth, provider)
			.then(async (result) => {
				localStorage.setItem(constants.IS_INTERNAL_LOGIN, 'true')
				const idToken = await result?.user.getIdToken();
				await dispatch(userActions.signIn(idToken, onSuccess, onFail));

				setInterval(async () => {
					const newToken = await result?.user.getIdToken(/* forceRefresh */ true);
					await dispatch(userActions.updateUserToken(newToken));
					// Update the token in your frontend state or storage
				}, 55 * 60 * 1000); // Refresh token every 55 minutes
			})
			.catch(e => {
				Toaster.showError('Login failed')
				setLoading(false)
				console.log("ERROR: ", e);
			})
	};

	const onSuccess = () => {
		navigate(Routes.HOME);
	};

	const onFail = () => {
		Toaster.showError('Login failed')
		console.log("login failed");
		setLoading(false);
	};

	return (
		<div className="internal-signin-container">

			{ loading && <LoadingPanel /> }

			<img src={logo} alt="" className="homepage-logo" />

			<div style={{position: 'absolute', bottom: '100px', left: '20vw'}}>
				<FloatingImage src={ball1} uid="ball1" animationDuration={2500} fromValue={0} toValue={-150} />
			</div>

			<div style={{position: 'absolute', bottom: '100px', left: '30vw'}}>
				<FloatingImage src={ball2} uid="ball2" animationDuration={1500} fromValue={-40} toValue={-120} />
			</div>

			<div style={{position: 'absolute', bottom: '100px', right: '20vw'}}>
				<FloatingImage src={ball3} uid="ball3" animationDuration={5000} fromValue={0} toValue={-230} />
			</div>

			<div className="internal-signin-box-wrapper">
				<div className="internal-signin-box">
					<div/>
					<div style={{fontSize: '22px', color: '#142A31', fontWeight: 700}}>Sign In</div>
					<div style={{fontSize: '14px', color: '#365A64'}}>Sign in with your Microsoft Account</div>
					<img src={loginWithMicrosoft} alt="" className="internal-signin-button" onClick={signIn} />
					<div />
				</div>
			</div>

			<div className="email-row">Email us at <a href="mailto:support@connact.cloud">support@connact.cloud</a> for any issues</div>
		</div>
	)
};

export default InternalSignInPage;
